import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import Main from "./Main";
import { Box, Typography } from "@mui/material";
import CheckCircle from '@mui/icons-material/CheckCircle';

const StatusChip = (props) => {
    const  isActive  = props.isActive
    const  text  = props.text
    return (
        <>
            {isActive && (
                <div style={{display:'flex',alignItems:'center'}}>
                <CheckCircle sx={{ color: '#66DA45' }} />
                      <Typography ml={1} variant="caption">{text}</Typography>
                </div>
           )}
            {!isActive && (
                <div style={{display:'flex',alignItems:'center'}}>
                    <CheckCircle sx={{ color: '#EDEDED' }} />
                    <Typography ml={1} color="#B7B7B7" variant="caption">{text}</Typography>
                </div>
           )}
        </>
    )
}

export default StatusChip